import html2canvasWithSettings from './html2canvasWithSettings';

export default async function downloadElementJpeg(element, fileName) {
  const canvas = await html2canvasWithSettings(element);
  canvas.toBlob(async (blob) => {
    const { default : FileSaver } = await import('file-saver');
    FileSaver.saveAs(blob, fileName);
  }, 'image/jpeg');
}
